import React from 'react';
import { render, fireEvent } from '@testing-library/react';
import Groups from '../Groups';

const sampleGroups = [
  {
    id: 1,
    name: 'Youth Group',
    description: 'For young people',
    schedule: 'Wednesdays 7pm',
    location: 'Room 101',
    image_url: 'https://example.com/youth.jpg',
    enrollment_status: 'Open',
    group_type_id: 'type-a',
    url: 'https://example.com/youth',
  },
  {
    id: 2,
    name: 'Bible Study',
    description: 'Weekly study',
    schedule: 'Tuesdays 6pm',
    location: 'Room 202',
    image_url: 'https://example.com/bible.jpg',
    enrollment_status: null,
    group_type_id: 'type-b',
    url: 'https://example.com/bible',
  },
  {
    id: 3,
    name: 'Prayer Team',
    description: null,
    schedule: null,
    location: null,
    image_url: null,
    enrollment_status: null,
    group_type_id: 'type-a',
    url: null,
  },
];

describe('Groups', () => {
  describe('empty state', () => {
    it('shows empty message when data is null', () => {
      const { getByText } = render(<Groups data={null} />);
      expect(
        getByText('No groups available at this time. Check back soon!')
      ).toBeInTheDocument();
    });

    it('shows empty message when data is empty array', () => {
      const { getByText } = render(<Groups data={[]} />);
      expect(
        getByText('No groups available at this time. Check back soon!')
      ).toBeInTheDocument();
    });

    it('shows empty message when filtered results are empty', () => {
      const { getByText } = render(
        <Groups
          data={sampleGroups}
          settings={{ 'pco-group-type': 'nonexistent' }}
        />
      );
      expect(
        getByText('No groups available at this time.')
      ).toBeInTheDocument();
    });
  });

  describe('cards layout (default)', () => {
    it('renders group cards', () => {
      const { getByText } = render(<Groups data={sampleGroups} />);
      expect(getByText('Youth Group')).toBeInTheDocument();
      expect(getByText('Bible Study')).toBeInTheDocument();
      expect(getByText('Prayer Team')).toBeInTheDocument();
    });

    it('renders group images', () => {
      const { container } = render(<Groups data={sampleGroups} />);
      const images = container.querySelectorAll('img.pco-card-image');
      expect(images.length).toBe(2); // 2 groups have images
    });

    it('renders enrollment badge when present', () => {
      const { getByText } = render(<Groups data={sampleGroups} />);
      expect(getByText('Open')).toBeInTheDocument();
    });

    it('renders description when present', () => {
      const { getByText } = render(<Groups data={sampleGroups} />);
      expect(getByText('For young people')).toBeInTheDocument();
      expect(getByText('Weekly study')).toBeInTheDocument();
    });

    it('renders Learn More link when no onItemClick', () => {
      const { getAllByText } = render(<Groups data={sampleGroups} />);
      const buttons = getAllByText('Learn More');
      expect(buttons.length).toBe(3);
      expect(buttons[0].tagName).toBe('A');
    });

    it('renders Learn More button when onItemClick is provided', () => {
      const onItemClick = jest.fn();
      const { getAllByText } = render(
        <Groups data={sampleGroups} onItemClick={onItemClick} />
      );
      const buttons = getAllByText('Learn More');
      expect(buttons[0].tagName).toBe('BUTTON');
      fireEvent.click(buttons[0]);
      expect(onItemClick).toHaveBeenCalledWith(1);
    });
  });

  describe('list layout', () => {
    it('renders groups as list items', () => {
      const { container, getByText } = render(
        <Groups data={sampleGroups} settings={{ 'pco-layout': 'list' }} />
      );
      expect(container.querySelector('.pco-groups-list')).toBeInTheDocument();
      expect(getByText('Youth Group')).toBeInTheDocument();
    });

    it('renders list images', () => {
      const { container } = render(
        <Groups data={sampleGroups} settings={{ 'pco-layout': 'list' }} />
      );
      const images = container.querySelectorAll('img.pco-list-image');
      expect(images.length).toBe(2);
    });
  });

  describe('filtering', () => {
    it('filters by group type', () => {
      const { getByText, queryByText } = render(
        <Groups
          data={sampleGroups}
          settings={{ 'pco-group-type': 'type-a' }}
        />
      );
      expect(getByText('Youth Group')).toBeInTheDocument();
      expect(getByText('Prayer Team')).toBeInTheDocument();
      expect(queryByText('Bible Study')).not.toBeInTheDocument();
    });

    it('limits displayed groups by count', () => {
      const { getByText, queryByText } = render(
        <Groups data={sampleGroups} settings={{ 'pco-count': '1' }} />
      );
      expect(getByText('Youth Group')).toBeInTheDocument();
      expect(queryByText('Bible Study')).not.toBeInTheDocument();
    });
  });

  describe('loading state', () => {
    it('renders groups grid for cards layout', () => {
      const { container } = render(<Groups data={sampleGroups} />);
      expect(container.querySelector('.pco-groups-grid')).toBeInTheDocument();
    });
  });
});
